import { Alert, AlertTitle } from "@mui/material";
import EnvironmentNames from "../config/EnvironmentNames";

function EnvironmentLabel() {
  if (EnvironmentNames.isCloudProd()) return null;

  return (
    <Alert
      severity={"info"}
      color={"warning"}
      sx={{
        ".MuiAlertTitle-root": {
          mb: 0,
        },
      }}>
      <AlertTitle noWrap>{EnvironmentNames.getCurrentName()}</AlertTitle>
    </Alert>
  );
}

export default EnvironmentLabel;
